/*
 * @Author: wangxiang 
 * @Date: 2019-11-24 15:53:45 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-12-02 21:44:53
 */
export default {
  routes: [
    {
      path: '/album',
      name: 'album',
      component: () => import('@/module/album/album.vue'),
      meta: {
        title: '电子相册',
        keepAlive: false,
        logined: true
      }
    },
    {
      path: '/album_detail',
      name: 'album_detail',
      component: () => import('@/module/album/albumDetail.vue'),
      meta: {
        title: '电子相册',
        keepAlive: false,
        logined: true
      }
    },
    {
      path: '/album_view',
      name: 'album_view',
      component: () => import('@/module/album/albumDetail.vue'),
      meta: {
        title: '电子相册',
        keepAlive: false,
        logined: false
      }
    },
    {
      path: '/album_preview',
      name: 'album_preview',
      component: () => import('@/module/album/albumPreview.vue'),
      meta: {
        title: '电子相册',
        keepAlive: false,
        logined: false
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/Album.js